import { PROJECT_KEYS } from '@shared/constants/keys/keys';

//------------------------------------------------------------------------------
//                            Поиск гифки
//------------------------------------------------------------------------------
export const searchGifs = async (query, limit = 20) => {
  try {
    const searchParams = new URLSearchParams({
      key: 'AIzaSyCFumx_kbSTJuV7xtJzITj1UyOtWJpYe7k',   
      limit: limit.toString(),
      media_filter: 'minimal',
      contentfilter: 'medium',
      locale: 'ru',
      q: query,
    });
    const url = `https://tenor.googleapis.com/v2/search?${searchParams}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Ошибка запроса: ' + response.statusText);
    }
    const data = await response.json();
    return data.results;
  } catch (error) {
    console.error('Программная ошибка загрузки изображения: Error fetching get comments list:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx


//------------------------------------------------------------------------------
//                            Выбор гифки
//------------------------------------------------------------------------------
export const getTrendingGifs = async (limit = 20) => {
  try {
    const searchParams = new URLSearchParams({
      key: 'AIzaSyCFumx_kbSTJuV7xtJzITj1UyOtWJpYe7k',   
      limit: limit.toString(),
      media_filter: 'minimal',
      contentfilter: 'medium',
      locale: 'ru',
    });
    const url = `https://tenor.googleapis.com/v2/featured?${searchParams}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Ошибка запроса: ${response.statusText}`);
    }
    const data = await response.json();
    return data.results; // Массив трендовых GIF
  } catch (error) {
    console.error('Ошибка получения трендов GIF:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx